import {Switch as SwitchBase} from '@yandex-delivery/blocks'
import {noop} from '@yandex-delivery/utils'
import React, {useCallback} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {scoped} from '../../utils'
import {SwitchProps} from './Switch.types'

export function Switch({
  name,
  rules,
  defaultValue,
  shouldUnregister,
  onChange: onChangeProp = noop,
  ...switchProps
}: SwitchProps): React.ReactElement<SwitchProps> {
  const {control} = useFormContext()

  const {
    field: {onChange, value, onBlur},
  } = useController({
    control,
    name,
    rules,
    defaultValue,
    shouldUnregister,
  })

  const isChecked = Boolean(value)

  const handleChange = useCallback(
    (on: boolean, e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(on)
      onChangeProp(on, e)

      // Без этого вызова стейт формы не учитывал изменения этого инпута,
      // если изменяем после редактирования другого поля формы
      onBlur()
    },
    [onChange, onChangeProp, onBlur],
  )

  return <SwitchBase name={name} on={isChecked} onChange={handleChange} {...switchProps} />
}

export const ScopedSwitch = scoped(Switch, {valueKey: 'on'})
